//./plugins/posthog.js
import posthog from "posthog-js";

export default {
  install(app) {
    app.config.globalProperties.$posthog = posthog.init(
      'phc_2Y4J3X3NvALcpOCH7M6WDg5VNZ5e5UjcE2d8w2Bvrwf',
      {
        api_host: 'https://us.i.posthog.com',
      }
    );
  },
};